import React, { useId, useRef } from 'react';
import { ValuePillButton } from './PillButton';
import { Popover2025 } from '@ardoq/popovers';
import { useDropdownTriggerContainer } from '@ardoq/dropdown-2026';
import { FlexBox } from '@ardoq/layout';
import {
  DatePopoverProps,
  DateRangePopoverProps,
  ListPopoverProps,
  NumberPopoverProps,
  NumberRangePopoverProps,
  PopoverContent,
  RelativeDatePopoverProps,
  StringPopoverProps,
} from './Popover';
import { HierarchicalListPopoverProps } from './HierarchicalListPopover';

export type ValueButtonProps = {
  button: {
    isDisabled?: boolean;
    isPopoverOpen: boolean;
    onClick: VoidFunction;
    label: string;
  };
  popover: {
    isOpen: boolean;
    onClose: VoidFunction;
    content:
      | ListPopoverProps
      | HierarchicalListPopoverProps
      | StringPopoverProps
      | NumberPopoverProps
      | NumberRangePopoverProps
      | DatePopoverProps
      | DateRangePopoverProps
      | RelativeDatePopoverProps;
  };
  filterLabel: string;
  editValueAriaLabel?: (filterLabel: string) => string;
};

export const ValueButton = (props: ValueButtonProps) => {
  const popoverId = useId();
  const triggerRef = useDropdownTriggerContainer<HTMLButtonElement>({
    isOpen: props.button.isPopoverOpen,
    openDropdown: () => !props.button.isPopoverOpen && props.button.onClick(),
  });
  const anchorRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <FlexBox align="stretch" ref={anchorRef}>
        <ValuePillButton
          ref={triggerRef}
          $isActive={props.button.isPopoverOpen}
          disabled={props.button.isDisabled}
          onClick={props.button.onClick}
          aria-label={
            props.editValueAriaLabel?.(props.filterLabel) ??
            `Edit ${props.filterLabel} filter value`
          }
          aria-haspopup="dialog"
          aria-expanded={props.button.isPopoverOpen}
          aria-controls={popoverId}
        >
          {props.button.label}
        </ValuePillButton>
      </FlexBox>
      <Popover2025
        focusContent
        id={popoverId}
        isOpen={props.popover.isOpen}
        onClose={props.popover.onClose}
        onClickOutside={props.popover.onClose}
        anchorRef={anchorRef}
        placement={{
          side: 'bottom',
          overflow: 'right',
        }}
      >
        <PopoverContent {...props.popover.content} />
      </Popover2025>
    </>
  );
};
